export const BACK_BUTTON_ON_HEADER_CLICKED = 'BACK_BUTTON_ON_HEADER_CLICKED';
export const CHANGE_CLOSE_TO_BACK_ICON_ON_HEADER = 'CHANGE_CLOSE_TO_BACK_ICON_ON_HEADER';
